/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react'
import './InOutMessageStyle.css'
import useInOutMessage from './useInOutMessage'
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import ChartComponent from '@components/common/Chart/ChartComponent.component'
import { marketingOverviewFilter } from '@dataTypes/marketing.type'

interface InOutMessageProps {
  overviewDateFilter: marketingOverviewFilter
}

const InOutMessage: React.FC<InOutMessageProps> = ({ overviewDateFilter }) => {
  const hooks = useInOutMessage(overviewDateFilter)

  const tooltipTemplate = useCallback((args: any): JSX.Element => {
    return (
      <div className="mmc-custom-tooltip">
        <div className="tooltip-date">{args.x}</div>
        <div className="tooltip-series" style={{ color: args.color }}>
          <span>
            <span
              className="tooltip-series-marker"
              style={{
                backgroundColor: args.series.interior,
              }}
            />
            {args.series.properties.name}
          </span>
          <span>{args.y}</span>
        </div>
      </div>
    )
  }, [])

  return (
    <div className="mo-a-in-out-message mo-board">
      <div className="mo-a-mo-header">
        <div className="mo-a-mo-header-left">
          <span className="mo-secondary-header">
            Inbound vs. outbound messages
          </span>
          <DropDownListComponent
            dataSource={hooks.campaignDropdownOptions}
            placeholder="Select campaign"
            value={hooks.selectedCampaign}
            change={(e) => hooks.setSelectedCampaign(e.value)}
          />
        </div>
      </div>
      <ChartComponent
        id="in-out-message-bar"
        columnWidth={0.8}
        columnSpacing={0.1}
        cornerRadius={{
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        }}
        data={hooks.data}
        height="290px"
        tooltipTemplate={tooltipTemplate}
        type="Column"
        xName="x"
        yName={['Inbound', 'Outbound']}
        yColor={['#ED9A5E', '#E3B016']}
      />
    </div>
  )
}

export default InOutMessage
